export default "__VITE_ASSET__BXFJEALi__"